import { render } from "./SGIcon.vue?vue&type=template&id=6dba51b8"
const script = {}

import exportComponent from "/Users/Carl/Develop/go/src/github.com/Soesah/soesahgaming.lostmarbles.nl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__